export default __webpack_public_path__ + "static/media/broken-image.7b90e8a9.png";